<template>
    <div class="fileDragDrop" :class="{showOutline: showOutline || dragging, dragging: dragging}">
        <div class="uploadContainer">
            <slot v-if="dragging === false || !$slots.dragging"></slot>
            <slot v-else name="dragging"></slot>
        </div>
    </div>
</template>

<script>
  import Dropzone from 'dropzone';

  export default {
    name: "file-drag-drop",
    props: {
      value: {
        type: Array,
        required: false,
        default: () => []
      },
      showOutline: {
        type: Boolean,
        default: () => false
      },
      maxFiles: {
        type: Number,
        default: () => Infinity
      },
      validTypes: {
        type: Array,
        required: false,
        default: () => [
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          'application/msword',
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          'application/vnd.ms-excel',
          'application/pdf',
          'text/plain',
          'text/xml',
          'text/html',
          'text/csv'
        ]
      }
    },
    data: () => {
      return {
        timeout: null,
        dragging: false
      };
    },
    mounted() {
      this.d = new Dropzone(this.$el.querySelector('.uploadContainer'), {
        url: '/',
        clickable: false,
        autoProcessQueue: false,
        previewTemplate: '<div> </div>',
        dragover: this.dragOver.bind(this),
        addedfile: this.addFile.bind(this)
      });
    },
    methods: {
      dragOver(event) {
        if (this.value.length < this.maxFiles) {
          this.dragging = true;

          if (this.timeout !== null) {
            clearTimeout(this.timeout);
          }

          this.timeout = setTimeout(() => {
            this.dragging = false;
            this.timeout = null;
          }, 200);
        }
      },
      addFile(file) {
        var valid = _.indexOf(this.validTypes, file.type) >= -1;
        if (valid && this.value.length < this.maxFiles) {
          this.value.push(file);
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
    @include drag-drop();
</style>